import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Container, CssBaseline, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const Sent = () => {
  const classes = useStyles()

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          仮予約申込の完了
        </Typography>
        <br />
        <p>
          確認メールをお送りしました
          <br />
          ご予約内容を必ずご確認ください。
        </p>
        <p>
          ※ 仮予約のため、ご予約は確定しておりません
          <br />
          ご注意ください
        </p>
      </div>
    </Container>
  )
}

export default Sent
